<section class="user-page" id="container">
  <app-menu></app-menu>
  <section id="main-content">
    <section class="wrapper">
      <div class="header">
        <h3 class="title" i18n="user billing page title|The title of the user billing page shown to authenticated users@@userBillingPageTitle">Billing Overview</h3>
      </div>
      <div *ngIf="error.active">
        <div class="alert alert-danger">{{ error.message }}</div>
        <pre style="display: none">{{ error.stack }}</pre>
      </div>
      <div *ngIf="!error.active" class="content">
        <div class="card-holder full-width">
          <app-kpi-card
            i18n-title="@@monthlyPaymentLabelBilling"
            title="Monthly payment"
            icon="fa-dollar"
            [value]="(invoiceList && invoiceList[invoiceList.length-1] ? invoiceList[invoiceList.length-1].billingValueString || 'N/A' : '...')"
          ></app-kpi-card>
          <app-kpi-card
            i18n-title="monthly message limit dashboard kpi title|The title of the card that has the total messages allowed@@monthlyMessageLimitDashboardKpi"
            title="Monthly message limit"
            icon="fa-envelope"
            [value]="plan ? ((plan.deliveriesQuantity === -1 ? 'Unlimited' : plan.deliveriesQuantity) || '...') : '...'"
          ></app-kpi-card>
          <app-plan-card
            [hasManageButton]="true"
            [value]="plan ? plan.name : null"
            [expiration]="plan ? plan.expirationDate : null"
          ></app-plan-card>
        </div>
        <div class="invoice-details full-width">
          <div class="panel last-invoice loading-wrapper" *ngIf="!invoiceList"><i class="fa fa-circle-o-notch fa-spin fa-4x"></i></div>
          <div class="panel last-invoice" *ngIf="invoiceList">
            <div class="panel-title-row">
              <h4 class="title" *ngIf="invoiceList[invoiceList.length-1] && invoiceList[invoiceList.length-1].paid" i18n="The text before the numeric id of a paid invoice@@paidInvoiceBillingPrefix">Last Billing:</h4>
              <h4 class="title" *ngIf="!(invoiceList[invoiceList.length-1] && invoiceList[invoiceList.length-1].paid)" i18n="The text before the numeric id of an unpaid invoice@@unpaidInvoiceBillingPrefix">Last Billing:</h4>
              <span class="value">{{ invoiceList[invoiceList.length-1] ? '#' + invoiceList[invoiceList.length-1].id : 'None' }}</span>
            </div>
            <div class="panel-details">
              <div class="panel-detail-row amount">
                <label i18n="The text before the price of the recurrent billing value of the current month@@currentMonthBillingAmountLabel">Amount</label>
                <span>{{ invoiceList[invoiceList.length-1] ? invoiceList[invoiceList.length-1].billingValueString : 'N/A' }}</span>
              </div>
              <div class="panel-detail-row date">
                <label i18n="The text before the expiration date of the recurrent billing value of the current month@@currentMonthBillingExpirationDateLabel">Billing Date</label>
                <span>{{ invoiceList[invoiceList.length-1] ? invoiceList[invoiceList.length-1].billingDateString : 'N/A' }}</span>
              </div>
              <div class="panel-detail-row status">
                <label>Status</label>
                <span>{{ invoiceList[invoiceList.length-1] ? invoiceList[invoiceList.length-1].statusString : 'N/A' }}</span>
              </div>
              <div class="panel-detail-row description hidden">
                <label>Description</label>
                <input #descriptionText type="text" [value]="invoiceList[invoiceList.length-1] ? invoiceList[invoiceList.length-1].description : ''" />
              </div>
            </div>
            <div class="invoice-actions right-align">
              <a role="button" target="_blank" *ngIf="invoiceList[invoiceList.length-1]" [href]="invoiceList[invoiceList.length-1].billingUrl" class="btn btn-primary" i18n="@@openPaymentDocumentButtonLabel">Open Document</a>
              <button role="button" class="btn btn-primary btn-with-left-icon" style="margin-left: 10px" (click)="onCopyDocumentClick()">
                <i class="fa fa-clipboard" *ngIf="!hasCopied"></i>
                <i class="fa fa-check" *ngIf="hasCopied"></i>
                <span i18n="@@copyDocumentButtonLabel">Copy Payment Data</span>
              </button>
            </div>
          </div>
          <div class="panel billing-details loading-wrapper" *ngIf="!billingDetails"><i class="fa fa-circle-o-notch fa-spin fa-4x"></i></div>
          <div class="panel billing-details" *ngIf="billingDetails">
            <div class="panel-title-row">
              <h4 class="title" i18n="Title of the billing details in the billing page@@billingDetailListSectionTitle">Billing details</h4>
              <button *ngIf="!billingDetails.editing && false" role="button" type="button" class="btn btn-default btn-sm edit" (click)="onEditBillingDetailsClick()"><i class="fa fa-pencil"></i></button>
            </div>
            <div class="panel-details">
              <div class="panel-detail-row company">
                <label i18n="The label before the specified company of the billing@@billingCompanyPrefixLabel">Company</label>
                <span *ngIf="!billingDetails.editing">{{ billingDetails.company }}</span>
                <input type="text" class="form-control" name="company" *ngIf="billingDetails.editing" [value]="billingDetails.company" />
              </div>
              <div class="panel-detail-row payment-method">
                <label i18n="@@userBillingPaymentMethodTitle">Payment Method</label>
                <span *ngIf="!billingDetails.editing">{{ getFriendlyPaymentString(billingDetails.paymentMethod) }}</span>
                <select *ngIf="billingDetails.editing"  class="form-control" name="payment-method" [value]="billingDetails.paymentMethod">
                  <option value="billet" i18n="Billet option as the payment method@@billetPaymentOption">Billet</option>
                  <option value="credit-card" i18n="Credit card option as the payment method@@creditCardPaymentOption">Credit Card</option>
                  <option value="bank-transfer" i18n="Bank transfer option as the payment method@@bankTransferPaymentOption">Bank Transfer</option>
                </select>
              </div>
              <div class="panel-detail-row next-billing-date" *ngIf="billingDetails.nextBillingDate !== null">
                <ng-container *ngIf="!billingDetails.editing">
                  <label i18n="The label before the date of the next billing date@@nextBillingDatePrefixLabel">Next billing date</label>
                  <span>{{ billingDetails.nextBillingDate }}</span>
                </ng-container>
                <ng-container *ngIf="billingDetails.editing">
                  <label i18n="Billing day label at user billing page@@billingLabelUserBillingPage">Billing day</label>
                  <select class="form-control" name="billing-day" [value]="billingDetails.billingDay">
                    <option value="5">5</option>
                    <option value="10">10</option>
                    <option value="15">15</option>
                    <option value="20">20</option>
                    <option value="25">25</option>
                  </select>
                </ng-container>
              </div>
              <div class="panel-detail-row billing-country">
                <label i18n="Country at user billing page@@countryLabelUserBillingPage">Country</label>
                <span *ngIf="!billingDetails.editing">{{ billingDetails.country }}</span>
                <input type="text" class="form-control" name="country" *ngIf="billingDetails.editing" [value]="billingDetails.country" />
              </div>
              <div class="panel-detail-row action" *ngIf="billingDetails.editing">
                <button role="button" type="button" class="btn btn-default cancel btn-with-left-icon" (click)="onCancelEditBillingDetailsClick()">
                  <i class="fa fa-close"></i>
                  <span i18n="Cancel button label at user billing page@@cancelButtonLabelUserBillingPage" i18n="@@genericCancelButtonLabel">Cancel</span>
                </button>
                <button role="button" type="button" class="btn btn-default save btn-with-left-icon" (click)="onSaveBillingDetailsClick()">
                  <i class="fa fa-save"></i>
                  <span i18n="Save button label at user billing page@@saveButtonLabelUserBillingPage">Save</span>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="full-width invoice-history">
          <div class="panel">
            <div class="panel-title-row">
              <h4 class="title" i18n="Title of the invoice history table section in the billing page with logs about previously paid or unpaid invoices@@invoiceHistoryTableSectionTitle">Invoice History</h4>
              <button role="button" type="button" class="btn btn-default btn-sm refresh" (click)="onUpdateInvoiceHistoryClick()"><i class="fa fa-refresh"></i></button>
            </div>
            <div class="panel-body">
              <app-filterable-paginated-table
                [columns]="columns"
                [data]="invoiceList || []"
                pageSize="10"
                paginationButtonsAllowed="19"
                [loading]="!invoiceList"
                width="100%"
              ></app-filterable-paginated-table>
            </div>
          </div>
        </div>
      </div>
    </section>
  </section>
</section>
